import { render } from "./search-input.2.vue?vue&type=template&id=5423298a&scoped=true&lang=true"
import script from "./search-input.2.vue?vue&type=script&lang=js"
export * from "./search-input.2.vue?vue&type=script&lang=js"

import "./search-input.2.vue?vue&type=style&index=0&id=5423298a&lang=scss"
import "./search-input.2.vue?vue&type=style&index=1&id=5423298a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5423298a"]])

export default __exports__